"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.strToTitle = void 0;
const strToTitle = (str) => {
    // https://stackoverflow.com/a/46959528
    return str.toLowerCase().replace(/(^|\s)\S/g, function (t) {
        return t.toUpperCase();
    });
};
exports.strToTitle = strToTitle;
